export default __webpack_public_path__ + "static/media/graphic.7493029f.png";